import {Injectable} from '@angular/core';
import {DiagramCanvasService} from '../diagram-render/diagram-canvas/diagram-canvas.service';
import {ModeDataService} from './mode-data.service';

declare const mxEventObject: any;

@Injectable()
export class GraphModeService {
  constructor(
    private diagramCanvasSvc: DiagramCanvasService,
    private modeDataSvc: ModeDataService
  ) {}

  public set(mode: boolean) {
    const editorUI = this.diagramCanvasSvc.EditorUI;
    const editor = this.diagramCanvasSvc.Editor;
    const graph = this.diagramCanvasSvc.graph;

    graph.setGridEnabled(mode);
    editor.updateGraphComponents();
    editorUI.fireEvent(new mxEventObject('gridEnabledChanged'));

    if (!mode) {
      graph.selectionModel.clear();
      graph.popupMenuHandler.hideMenu();
    }

    graph.enabled = mode;
  }

  public get() {
    return this.modeDataSvc.isEditMode() && this.diagramCanvasSvc.graph.enabled;
  }
}
